import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrydetailpageService } from '../countrydetailpage.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-country-detail-features',
  templateUrl: './country-detail-features.component.html',
  styleUrls: ['./country-detail-features.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class CountryDetailFeaturesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  constructor(
    private contentful: ContentfulService,
    private countryDetailPageService: CountrydetailpageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  featuresData: any;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    if (!this.pageData) return;
    const data = this.pageData;
    if (data != null && data.features && data.features.length > 0) {
      this.featuresData = data.features;
    }
  }
}
